export class AddressLookupResponse {
    constructor(response) {
        if (!response) {
            throw new Error("Missing address lookup response data");
        }
        this.response = response;
    }
    getAddress() {
        return {
            city: this.response.city,
            name: this.response.name,
            givenName: this.response.givenName,
            surname: this.response.surname,
            postalCode: this.response.postalCode,
            street: this.response.street,
            street2: this.response.street2,
            distance: this.response.distance,
        };
    }
}
